module.exports = __webpack_public_path__ + "img/LT300044067.b7dab79b.png";